import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListItemTypeRequest extends IBaseRequest {
    timestamp?:   string;
    limit?:       string;
    offset?:      string;
    orderBy?:     string;
    countOnly?:   string;
    orderByType?: string;
    relatedItem?: string;
    treeHandle?:  string;
    type?:        string;
}

export class ListItemTypeRequest extends BaseRequest implements IListItemTypeRequest {
    public timestamp?:   string;
    public limit?:       string;
    public offset?:      string;
    public orderBy?:     string;
    public countOnly?:   string;
    public orderByType?: string;
    public relatedItem?: string;
    public treeHandle?:  string;
    public type?:        string;

  constructor(server: string, session: string, otherOptions?: IListItemTypeRequest) {
    super(server, session);
    if(otherOptions){
        this.timestamp = otherOptions.timestamp;
        this.limit = otherOptions.limit;
        this.offset = otherOptions.offset;
        this.orderBy = otherOptions.orderBy;
        this.countOnly = otherOptions.countOnly;
        this.orderByType = otherOptions.orderByType;
        this.relatedItem = otherOptions.relatedItem;
        this.treeHandle = otherOptions.treeHandle;
        this.type = otherOptions.type;
    }
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.timestamp, 'timestamp');
    parameters += this.makeNode(this.limit, 'limit');
    parameters += this.makeNode(this.offset, 'offset');
    parameters += this.makeNode(this.orderBy, 'orderBy');
    parameters += this.makeNode(this.countOnly, 'countOnly');
    parameters += this.makeNode(this.orderByType, 'orderByType');
    parameters += this.makeNode(this.relatedItem, 'relatedItem');
    parameters += this.makeNode(this.treeHandle, 'treeHandle');
    parameters += this.makeNode(this.type, 'type');

    return super.wrapperXml('ListItemType', parameters);
  }
}
